import React, {Component} from 'react';
import Paper from '@material-ui/core/Paper';
import {createMuiTheme, MuiThemeProvider, withStyles} from '@material-ui/core/styles';
import {fetchTags} from '../../../actions/connectionActions';
import history from "../../../history";
import MUIDataTable from "mui-datatables";
import _ from "lodash";
import {connect} from "react-redux";
import PropTypes from 'prop-types';

const columns = [
  {
    name: "_id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
      display: false
    },
  },
  {
    name: "email",
    label: "Email",
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: "createdAt",
    label: "Created At",
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: "updatedAt",
    label: "Updated At",
    options: {
      filter: false,
      sort: true,
    },
  },
];

const tableOptions = {
  filterType: "checkbox",
  onRowClick: (rowData, rowState) => {
    // console.log(rowData, rowState);
    history.push(`/dashboard/admin/tags/edit/${rowData[0]}`)
  },
  print: false,
  rowsPerPageOptions: [25, 50, 100],
  rowsPerPage: 100,
  responsive: "scrollMaxWidth",
  filter: false,
  download: false,
};

const styles = theme => ({
  paper: {
    // maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
});

class TagTableContainer extends Component {

  componentDidMount() {
    this.props.fetchTags();
  }

  getMuiTheme = () => createMuiTheme({
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          // backgroundColor: "#ff0000"

        },
        paper: {
          // backgroundColor: "primary"
        }
      }
    }
  });

  render() {
    const {classes} = this.props;
    return (
      _.isEmpty(this.props.tags) ? null :
        <Paper className={classes.paper}>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            {/*<TagTable rows={this.props.tags}/>*/}
            <MUIDataTable
              title="Connection List"
              data={this.props.tags}
              columns={columns}
              options={tableOptions}
            />
          </MuiThemeProvider>

        </Paper>
    );
  }
}

TagTableContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    tags: Object.values(state.tags.tags),
    tag: state.tags.tag
  }
};

TagTableContainer = connect(mapStateToProps, {fetchTags})(TagTableContainer);
TagTableContainer = withStyles(styles)(TagTableContainer);


export default TagTableContainer;

